import { render, staticRenderFns } from "./OptimaIntegration.vue?vue&type=template&id=1284504e&"
import script from "./OptimaIntegration.vue?vue&type=script&lang=js&"
export * from "./OptimaIntegration.vue?vue&type=script&lang=js&"
import style0 from "./OptimaIntegration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports